import RootLayout from "@/app/layout";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Typography, Container, Box } from '@mui/material';
import data from '../../data/impressum/data.json';
import Head from "next/head";

export const metadata = {
  title: 'Hebamme Lea Stiffler | Impressum',
  canonicalUrl: 'https://hebamme-leastiffler.ch/impressum'
}

export async function getStaticProps() {
  return { props: { data } }
}

export default function Impressum({ data }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { Kontakt, Firma } = data;

  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }} 
      >
        <div className="section-header">
          <div className="section-title">
            <Typography variant="h3" component="h1" gutterBottom align="center">
              {data.Titel}
            </Typography>
          </div>
        </div>
        <div className="section-body">
          <Container maxWidth="lg">
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6" component="h2">Kontakt</Typography>
              <Typography>{Kontakt.Name}</Typography>
              <Typography>{Kontakt.Strasse}</Typography>
              <Typography>{Kontakt.Postleitzahl} {Kontakt.Ort}, {Kontakt.Land}</Typography>
              <Typography>Email: <a href={`mailto:${Kontakt.EMail}`} style={{ textDecoration: 'none' }}>{Kontakt.EMail}</a></Typography>
              <Typography>Mobile: <a href={`tel:${Kontakt.Mobile}`} style={{ textDecoration: 'none' }}>{Kontakt.Mobile}</a></Typography>
            </Box>
            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" component="h2">Firmeninformation</Typography>
              <Typography>UID: {Firma.UID}</Typography>
              <Typography>Bezeichnung: {Firma.Bezeichnung}</Typography>
            </Box>
          </Container>
        </div>
      </motion.section>
    </RootLayout>
  );
}
